import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl/dist';
import { ConditionalRendering } from '../../../../components/common/conditional-rendering';
import { REINSTATEMENT_STATUS } from '../../../../constants/enrollments/enrollments.constants';
import { IMember } from '../../../custom-grouping/types/customGroupingTypes';
import { getDuplicateMemberStrings } from '../common/enrollmentUtils';

interface ISuccessErrorProps {
    message?: string | string[];
    isTrue: boolean;
    heading?: string;
    data?: { status: string; duplicateMemberMap: { [key: string]: IMember } };
}

export const ModalTransactionSuccess = ({ message, isTrue, data }: ISuccessErrorProps) => {
    const intl = useIntl();
    return (
        <ConditionalRendering isTrue={isTrue}>
            <h3 data-testid="success-heading">
                {intl.formatMessage({ id: 'member.enrollment.modal.successHeading' })}
            </h3>
            {Array.isArray(message) ? (
                message.map((msg, index) => (
                    <p key={index} data-testid={`success-message-${index}`}>
                        {msg}
                    </p>
                ))
            ) : (
                <p data-testid="success-message">{message}</p>
            )}
        </ConditionalRendering>
    );
};

export const ModalTransactionError = ({
    message,
    isTrue,
    data,
    heading = 'member.enrollment.modal.errorHeading',
}: ISuccessErrorProps) => {
    const intl = useIntl();
    return (
        <ConditionalRendering isTrue={isTrue}>
            <h3 data-testid="error-heading">{intl.formatMessage({ id: heading })}</h3>
            <ConditionalRendering isTrue={!!message}>
                {Array.isArray(message) ? (
                    message.map((msg, index) => (
                        <p key={index} data-testid={`error-message-${index}`}>
                            {msg}
                        </p>
                    ))
                ) : (
                    <p data-testid="error-message">{message}</p>
                )}
            </ConditionalRendering>

            <ConditionalRendering
                isTrue={
                    data?.status !== REINSTATEMENT_STATUS.CANNOT_REINSTATED &&
                    data?.status !== REINSTATEMENT_STATUS.SUBSEQUENT_APP_SUBMITTED
                }
            >
                <p data-testid="error-message">
                    <FormattedMessage id={'cap.applications.modal.srsubmissionfailcontent'} />
                </p>
                <p data-testid="error-message">
                    <FormattedMessage id={'cap.applications.modal.csrsubmissionfailcontent2'} />
                </p>
            </ConditionalRendering>
            <ConditionalRendering isTrue={data?.status === REINSTATEMENT_STATUS.CANNOT_REINSTATED}>
                <p data-testid="error-message">
                    <FormattedMessage id={'member.enrollment.modal.reinstate.errorMessage'} />
                </p>
                <p data-testid="error-message">
                    <FormattedMessage id={'member.enrollment.modal.reinstate.overlapmemberdetails'} />
                </p>
                {data?.duplicateMemberMap &&
                    getDuplicateMemberStrings(data.duplicateMemberMap).map(duplicateMember => <p>{duplicateMember}</p>)}
            </ConditionalRendering>

            <ConditionalRendering isTrue={data?.status === REINSTATEMENT_STATUS.SUBSEQUENT_APP_SUBMITTED}>
                <p data-testid="error-message">
                    <FormattedMessage id={'member.enrollment.modal.reinstate.reinstatederror2'} />
                </p>
            </ConditionalRendering>
        </ConditionalRendering>
    );
};
